import { useState } from "react";
import { Link } from "react-router-dom";
import { useAdmin } from "../context/adminContext";
import { Menu, X } from "lucide-react";

function Navbar() {
  const { admin, logout } = useAdmin();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="mb-16" role="banner">
      <nav
        className="bg-orange-500 text-white px-6 py-5 fixed top-0 left-0 w-full z-50 shadow-md"
        aria-label="मुख्य नेव्हिगेशन"
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center relative">
          {/* Mobile Logo and Site Name */}
          <div className="flex items-center space-x-2 md:space-x-0 md:block">
            <div className="block md:hidden">
              <img
                src="/varkari_pariwar_logo.jpg"
                alt="वारकरी विचार परिवार लोगो"
                className="w-12 h-12 object-contain rounded-full"
                loading="lazy"
              />
            </div>
            <div className="text-lg font-bold text-left">
              <Link
                to="/"
                className="hover:text-yellow-300 block leading-tight"
                aria-label="मुख्यपृष्ठ - वारकरी विचार परिवार"
              >
                <span className="block md:inline font-yatra font-light">
                  वारकरी विचार{" "}
                </span>
                <span className="block md:inline font-yatra font-light">
                  परिवार तीर्थयात्रा
                </span>
              </Link>
            </div>
          </div>

          {/* Center Logo */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 top-1/2 -translate-y-1/2">
            <div className="border-4 border-white rounded-full mt-12">
              <img
                src="/varkari_pariwar_logo.jpg"
                alt="Warkari Vichar Parivar central logo"
                className="w-24 h-24 object-contain rounded-full"
                loading="lazy"
              />
            </div>
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex space-x-6 items-center" role="navigation">
            <Link
              to="/"
              className="hover:text-yellow-300 font-yatra font-light"
              aria-label="मुख्यपृष्ठ"
            >
              मुख्यपृष्ठ
            </Link>
            <Link
              to="/upcoming"
              className="hover:text-yellow-300 font-yatra font-light"
              aria-label="पुढील यात्रा"
            >
              पुढील यात्रा
            </Link>
            <Link
              to="/past-yatra"
              className="hover:text-yellow-300 font-yatra font-light"
              aria-label="मागील यात्रा"
            >
              मागील यात्रा
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? "Close menu" : "Open menu"}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isOpen && (
          <div
            id="mobile-menu"
            className="md:hidden mt-2 px-4 space-y-2 bg-orange-400 rounded-b shadow"
            role="menu"
            aria-label="Mobile Navigation Menu"
          >
            <Link
              to="/"
              className="block hover:text-yellow-300 font-yatra font-light"
              role="menuitem"
            >
              मुख्यपृष्ठ
            </Link>
            <Link
              to="/upcoming"
              className="block hover:text-yellow-300 font-yatra font-light"
              role="menuitem"
            >
              पुढील यात्रा
            </Link>
            <Link
              to="/past-yatra"
              className="block hover:text-yellow-300 font-yatra font-light"
              role="menuitem"
            >
              मागील यात्रा
            </Link>
          </div>
        )}
      </nav>

      {/* Admin Dashboard Button */}
      {admin && (
        <div className="flex justify-end mt-16 px-4">
          <Link
            to="/dashboard/yatra-list"
            className="bg-orange-500 text-white px-4 py-1 shadow hover:bg-orange-600 transition font-yatra font-light"
            aria-label="डॅशबोर्ड पहा"
          >
            डॅशबोर्ड
          </Link>
        </div>
      )}
    </header>
  );
}

export default Navbar;
